import {
  SVG_PICTURE_OUTLINED,
  SVG_PLAY_FILLED,
  SVG_MUSIC_FILLED,
  SVG_FILE_PDF_OUTLINED,
  SVG_ARCHIVE_OUTLINED,
  SVG_FILE_SPREADSHEET_OUTLINED,
  SVG_FILE_PRESENTATION_OUTLINED,
  SVG_FILE_TEXT_OUTLINED,
  SVG_FILE_CODE_OUTLINED,
  SVG_FILE,
} from '@getgo/chameleon-icons'

const ARCHIVE_TYPES = new Set([
  'application/zip',
  'application/x-zip-compressed',
  'application/x-rar-compressed',
  'application/x-7z-compressed',
  'application/x-tar',
  'application/gzip',
])

const SPREADSHEET_TYPES = new Set([
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/csv',
])

const PRESENTATION_TYPES = new Set([
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint',
])

const DOCUMENT_TYPES = new Set([
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'text/plain',
  'application/rtf',
])

const CODE_TYPES = new Set([
  'text/html',
  'text/css',
  'text/javascript',
  'application/javascript',
  'application/json',
  'application/xml',
  'text/xml',
  'application/x-sh',
  'application/x-python',
])

/**
 * Maps a MIME type to the most appropriate Chameleon SVG icon string.
 *
 * Priority order:
 * 1. `image/*` → picture icon
 * 2. `video/*` → filled play icon
 * 3. `audio/*` → filled music icon
 * 4. `application/pdf` → PDF icon
 * 5. Archives (zip, rar, 7z…) → archive icon
 * 6. Spreadsheets (xlsx, xls, csv) → spreadsheet icon
 * 7. Presentations (pptx, ppt) → presentation icon
 * 8. Word/text documents (docx, doc, txt) → text icon
 * 9. Code/script types (html, css, js, json, xml) → code icon
 * 10. Default → generic file icon
 *
 * @param mime - The MIME type string (e.g. `"image/jpeg"`, `"application/pdf"`).
 * @returns A Chameleon SVG string suitable for use in an `<chameleon-svg>` component.
 */
export function contentTypeToSvg(mime: string): string {
  if (mime.startsWith('image/')) {
    return SVG_PICTURE_OUTLINED
  }
  if (mime.startsWith('video/')) {
    return SVG_PLAY_FILLED
  }
  if (mime.startsWith('audio/')) {
    return SVG_MUSIC_FILLED
  }
  if (mime === 'application/pdf') {
    return SVG_FILE_PDF_OUTLINED
  }
  if (ARCHIVE_TYPES.has(mime)) {
    return SVG_ARCHIVE_OUTLINED
  }
  if (SPREADSHEET_TYPES.has(mime)) {
    return SVG_FILE_SPREADSHEET_OUTLINED
  }
  if (PRESENTATION_TYPES.has(mime)) {
    return SVG_FILE_PRESENTATION_OUTLINED
  }
  if (DOCUMENT_TYPES.has(mime)) {
    return SVG_FILE_TEXT_OUTLINED
  }
  if (CODE_TYPES.has(mime)) {
    return SVG_FILE_CODE_OUTLINED
  }
  return SVG_FILE
}
